import ApiJobExperience from 'types/api/JobExperience';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobExperience from 'models/JobExperience';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobExperience>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobExperiences, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobExperiences];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobExperience) => new JobExperience(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobExperience> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobExperience, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobExperience = data && data[ApiResources.JobExperience];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobExperience(resource);
};
